module.exports = __webpack_public_path__ + "assets/img/btn.5a175d04.png";